<template>
    <DashboardContainer>

        <DashboardTab
                :tabs="tabs"
                :selected-tab="selectedTab"
                @select="changeTab"
        />

        <ListWhatsappConfigs
                v-if="selectedTab===0"
                @update="handleUpdate"
        />

        <CreateWhatsappConfig
                v-if="selectedTab===1"
                :config="config"
        />

    </DashboardContainer>
</template>

<script>

import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardTab from "@/dashboard/tab/DashboardTab.vue";

import CreateWhatsappConfig from "@/dashboard/whatsapp/CreateWhatsappConfig.vue";
import ListWhatsappConfigs from "@/dashboard/whatsapp/ListWhatsappConfigs.vue";

export default {
    name: "WhatsappConfigBoard",

    components: {
        DashboardContainer,
        DashboardTab,
        CreateWhatsappConfig,
        ListWhatsappConfigs
    },

    data(){
        return{
            selectedTab : 0,

            tabs : [
                'List',
                'Create'
            ],

            config : {
                id : null,
                institutionId : null,
                phoneNumberId : '',
                wabaId : '',
                token : '',
                active : true
            }
        }
    },

    methods : {

        changeTab(tabIndex){
            this.selectedTab = tabIndex;
        },

        handleUpdate(config){
            this.config = {...config};
            this.selectedTab = 1;
        }
    }
}
</script>